import { render, staticRenderFns } from "./SubcontractorDetail.vue?vue&type=template&id=1b80f098&scoped=true"
import script from "./SubcontractorDetail.vue?vue&type=script&lang=js"
export * from "./SubcontractorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80f098",
  null
  
)

export default component.exports